import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, HostListener, Input, OnChanges, Output } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { TimerModule } from '../../timers/timer.module';
import { VideoStreamTrackingService } from '../video-stream-tracking.service';

@Component({
    selector: 'ms-video-stream-button',
    templateUrl: 'video-stream-button.component.html',
    styleUrl: './video-stream-button.component.scss',
    standalone: true,
    imports: [TimerModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoStreamButtonComponent implements OnChanges {
    @HostBinding('class') className = 'video-stream-button';
    @HostListener('click')
    onButtonClick(): void {
        if (!this.showCountdown) {
            this.buttonClicked.emit();
            this.trackingService.trackVideoStreamButtonClick(this.event.name);
        }
    }

    @Input() event: EventModel;
    @Input() isEventPending?: boolean;
    @Output() buttonClicked = new EventEmitter<void>();
    @Output() countDownEnded = new EventEmitter<void>();

    showCountdown: boolean;

    constructor(
        public sitecore: Sitecore,
        private trackingService: VideoStreamTrackingService,
    ) {}

    ngOnChanges(): void {
        this.showCountdown = this.isEventPending ? true : !this.event.scoreboard.started;
    }

    onCountdownEnded(): void {
        this.showCountdown = !!this.isEventPending;
        this.countDownEnded.emit();
    }
}
